import moment from 'moment';

class TimeHelper {
  
  wait(miliseconds) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(undefined);
      }, miliseconds)
    });
  }

  format(time) {
    return moment(time).format('DD/MM/YYYY HH:mm:ss');
  }
}

export default new TimeHelper();